export default function initLottie() {
    window.lottie = require('lottie-web');

    const $logo = $('[data-animation]');

    lottieActivate();

    $(window).scroll(() => {
        lottieActivate();
    });

    function lottieAnimate($section) {
        const $lottie = $section.find($('[data-lottie]'));
        if (!$lottie.hasClass('lottie-activated')) {
            $lottie.each(function () {
                lottie.loadAnimation({
                    container: $(this)[0],
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: $(this).data('lottie'),
                });
                $(this).addClass('lottie-activated');
            });
        }
    }

    function lottieActivate() {
        lottieAnimate($logo);
    }
}
